// Bounded offline palette, not every Unicode emoji. Keep whole sequences intact.
export const QUICK_REACTION_EMOJIS = ['❤️', '👍', '😂', '😮', '😢', '🙏'] as const;
export const REACTION_EMOJIS: readonly string[] = [
  ...QUICK_REACTION_EMOJIS,
  '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😊', '🙂', '😉', '😍', '🥰',
  '😘', '😎', '🤩', '🥳', '🤗', '🤔', '🤫', '🫡', '😌', '😴', '😇', '🥹',
  '😭', '😔', '😕', '😬', '🙄', '😳', '😱', '😤', '😡', '🤯', '🫠', '🤝',
  '👎', '👏', '🙌', '🫶', '👋', '✌️', '👌', '💪', '🤞', '🤟', '🫰', '💯',
  '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '💕', '💖', '💝',
  '🌸', '🌻', '🌹', '🌷', '🌼', '🍀', '🌿', '🌱', '🌳', '🌈', '☀️', '🌙',
  '🐱', '🐶', '🐰', '🦊', '🐻', '🐼', '🐨', '🐧', '🦋', '🐝', '🐢', '🐬',
  '🎉', '🎊', '🎂', '🎁', '🏆', '⭐', '✨', '🔥', '☕', '🍵', '🍓', '🍕',
  '✅', '❌', '❓', '💡', '🎯', '🚀',
];
